import { Autocomplete } from "@react-google-maps/api";
import { useContext, useEffect, useRef, useState } from "react";
import { getImages } from '../../../const'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TripContext } from "../../Context/TripContext";
import {DndContext, closestCenter } from "@dnd-kit/core";
import {SortableContext, arrayMove, verticalListSortingStrategy } from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import { Link, useNavigate } from "react-router-dom";

const TripDetails = ({ tmHeight, updateTripData, updateTripDataField, tripSubmit, tripInputData, setTripInputData, setExtraFields }) => {
    const navigate = useNavigate();
    const { tripData, addTripPoint, deleteTripPoint, reorderTripPoints, tripLoading } = useContext(TripContext);
    // Map data Fatch
    const originRef = useRef(null);
    const destinationRef = useRef(null);
    const addStopRef = useRef(null);
    // const [origin, setOrigin] = useState(null);
    // const [destination, setDestination] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [updatedTripData, setUpdatedTripData] = useState({ park_list: [] });

    useEffect(() => {
        if (tripData) {
            setUpdatedTripData(tripData);
        }
    }, [tripData]);
    // console.log("tripData", tripData)
    // console.log("updatedTripData", updatedTripData)
    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (!over || active.id === over.id) return;

        const oldIndex = tripData.park_list.indexOf(active.id);
        const newIndex = tripData.park_list.indexOf(over.id);

        reorderTripPoints(oldIndex, newIndex);
    };

    const increaseParks = () => {
        setTripInputData({
            ...tripInputData,
            num_parks: Number(tripInputData.num_parks || 0) + 1
        });
        setExtraFields({
            ...tripInputData,
            num_parks: Number(tripInputData.num_parks || 0) + 1
        });
    };

    const decreaseParks = () => {
        if (tripInputData.num_parks > 0) {
            setTripInputData({
                ...tripInputData,
                num_parks: Number(tripInputData.num_parks) - 1
            });
            setExtraFields({
                ...tripInputData,
                num_parks: Number(tripInputData.num_parks) - 1
            });
        }
    };

    //console.log("updatedTripData", updatedTripData);
    return (
        <>
            <div className='main-left' style={{ height: tmHeight ? tmHeight : "100vh" }}>
                <form onSubmit={tripSubmit}>
                    <div className='position-relative ml-block'>
                        <div className='sidebar-logo mb-5'>
                            <a href="/"><img src={getImages('WeGoScenic-logo.png')} alt='WeGoScenic' /></a>
                        </div>
                        <div className="trip-toggle mb-3">
                            <button
                                className={`toggle-btn ${tripInputData.trip_type === "one-way" ? "active" : ""}`}
                                onClick={() => updateTripDataField("trip_type", "one-way")}
                                type="button"
                            >
                                One Way
                            </button>

                            <button
                                className={`toggle-btn ${tripInputData.trip_type === "round-trip" ? "active" : ""}`}
                                onClick={() => updateTripDataField("trip_type", "round-trip")}
                                type="button"
                            >
                                Loop
                            </button>
                        </div>
                        <div className='tab-content'>
                            <div className='custom-form'>
                                <div className='row'>
                                    <div className='col-12 form-group'>
                                        {/* <div className='position-relative'>
                                                <input type='text' className='form-control' placeholder='Starting Point' name="origin" onChange={updateTripData}/>
                                                <span className='icon-location-pin icon-pos'></span>
                                            </div> */}
                                        <Autocomplete
                                            onLoad={(auto) => (originRef.current = auto)}
                                            onPlaceChanged={() => {
                                                if (!originRef.current) return;

                                                const place = originRef.current.getPlace();
                                                if (!place.geometry) return;

                                                const location = {
                                                    lat: place.geometry.location.lat(),
                                                    lng: place.geometry.location.lng(),
                                                };

                                                // setOrigin(location);

                                                // update form state
                                                updateTripData({
                                                    target: {
                                                        name: "origin",
                                                        value: place.formatted_address,
                                                    },
                                                });
                                            }}
                                        >
                                            <div className="position-relative">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Starting Point"
                                                    name="origin"
                                                    onChange={updateTripData}
                                                    value={tripInputData.origin}
                                                />
                                                <span className="icon-location-pin icon-pos"></span>
                                            </div>
                                        </Autocomplete>
                                    </div>
                                    <div className='col-12 form-group'>
                                        {/* <div className='position-relative'>
                                                <input type='text' className='form-control' placeholder='Destination' name="destination" onChange={updateTripData}/>
                                                <span className='icon-location-pin icon-pos'></span>
                                            </div> */}
                                        <Autocomplete
                                            onLoad={(auto) => (destinationRef.current = auto)}
                                            onPlaceChanged={() => {
                                                if (!destinationRef.current) return;

                                                const place = destinationRef.current.getPlace();
                                                if (!place.geometry) return;

                                                const location = {
                                                    lat: place.geometry.location.lat(),
                                                    lng: place.geometry.location.lng(),
                                                };

                                                // setDestination(location);

                                                // optional: also update your trip state
                                                updateTripData({
                                                    target: {
                                                        name: "destination",
                                                        value: place.formatted_address,
                                                    },
                                                });
                                            }}
                                        >
                                            <div className="position-relative">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Destination"
                                                    name="destination"
                                                    onChange={updateTripData}
                                                    value={tripInputData.destination}
                                                />
                                                <span className="icon-location-pin icon-pos"></span>
                                            </div>
                                        </Autocomplete>
                                    </div>
                                    {/* <div className='col-12 form-group'>
                                        <div className='position-relative'>
                                            <input type='number' className='form-control' placeholder='Number of Parks' name="num_parks" onChange={updateTripData} value={tripInputData.num_parks}/>
                                        </div>
                                    </div> */}
                                    <div className='col-12 form-group'>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="xs-title"># of Stops</div>
                                            <div className='position-relative d-inline-flex dp-box align-items-center '>
                                                <button
                                                    type="button"
                                                    className="btn dp-btn"
                                                    onClick={decreaseParks}
                                                >
                                                    -
                                                </button>
                                                <input
                                                    type='number'
                                                    className='form-control text-center'
                                                    placeholder='Number of Parks'
                                                    name="num_parks"
                                                    onChange={updateTripData}
                                                    value={tripInputData.num_parks}
                                                    readOnly
                                                />
                                                <button
                                                    type="button"
                                                    className="btn dp-btn"
                                                    onClick={increaseParks}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='col-12 form-group'>
                                        <div className='position-relative'>
                                            <input type='number' className='form-control' placeholder='Trip Length' name="trip_length" onChange={updateTripData} value={tripInputData.trip_length}/>
                                        </div>
                                    </div> */}
                                    {/* <div className='col-12 form-group'>
                                        <div className='position-relative'>
                                            <input type='number' className='form-control' placeholder='Number of Parks' name="num_parks" onChange={updateTripData} value={tripInputData.num_parks}/>
                                        </div>
                                    </div> */}
                                    {/* <div className='col-6 form-group'>
                                        <div className='position-relative'>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    updateTripData({
                                                        target: {
                                                            name: "start_date",
                                                            value: date
                                                        }
                                                    });
                                                }}
                                                placeholderText="Start Date"
                                                className="form-control"
                                                dateFormat="MM/dd/yyyy"
                                                popperPlacement="top-start"
                                            />
                                            <span className='icon-calendar icon-pos'></span>
                                        </div>
                                    </div>
                                    <div className='col-6 form-group'>
                                        <div className='position-relative'>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => {
                                                    setEndDate(date);
                                                    updateTripData({
                                                        target: {
                                                            name: "end_date",
                                                            value: date
                                                        }
                                                    });
                                                }}
                                                placeholderText="End Date"
                                                className="form-control"
                                                dateFormat="MM/dd/yyyy"
                                                minDate={startDate}
                                                popperPlacement="top-end"
                                            />
                                            <span className='icon-calendar icon-pos'></span>
                                        </div>
                                    </div> */}
                                </div>
                                <hr className='cs-hr' />
                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                    <div className='xs-title'>Your Trip</div>
                                    <div className='xxs-title'>{ 'park_list' in tripData ? tripData.park_list.length : 0 } stops</div>
                                </div>
                                <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                    <SortableContext
                                        items={ tripData?.park_list || []}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        <div className="trip-box-block mb-3">
                                            {(tripData?.park_list || []).map((v, i) => (
                                                <SortableItem key={v} id={v} index={i} label={v} 
                                                    onDelete={() => {
                                                        deleteTripPoint(v);
                                                        decreaseParks();
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </SortableContext>
                                </DndContext>
                                <div className='form-group'>
                                    <Autocomplete
                                        onLoad={(auto) => (addStopRef.current = auto)}
                                        onPlaceChanged={() => {
                                            if (!addStopRef.current) return;

                                            const place = addStopRef.current.getPlace();
                                            if (!place.geometry) return;

                                            const location = {
                                                lat: place.geometry.location.lat(),
                                                lng: place.geometry.location.lng(),
                                            };
                                            /*updateTripData({
                                                target: {
                                                    name: "stop_location",
                                                    value: place.formatted_address,
                                                },
                                            });*/

                                            addTripPoint(place.formatted_address);
                                        }}
                                    >
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Add a Stop"
                                                name="stop_location"
                                                onChange={updateTripData}
                                            />
                                            <span className="icon-magnifier icon-pos"></span>
                                        </div>
                                    </Autocomplete>
                                </div>
                                <hr className='cs-hr' />
                                <div className='scenic-mode-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-md-2'>
                                        <div className='xs-title'>Scenic Mode</div>
                                        <div>
                                            <div
                                                className={`switch ${tripInputData.scenic_mode ? "active" : ""}`}
                                                onClick={() => updateTripDataField("scenic_mode", !tripInputData.scenic_mode)}
                                            >
                                                <div className="switch-circle" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='xxs-title d-none d-md-block'>Prioritize sightseeing over speed</div>
                                </div>
                                {!tripLoading ? <button className='btn text-center common-btn start-trip-btn align-items-center d-inline-flex justify-content-center' type='submit'>
                                    <img className='pe-1' src={getImages('send-icon.png')} />
                                    <div className='pe-2'>Update Trip</div>
                                </button> :
                                    <>
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden"></span>
                                        </div>
                                        <div className='ms-2'>Loading</div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default TripDetails